const authConfig = {
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    redirectUri: `${process.env.REACT_APP_BASE_URL}/api/user/auth0/callback`,
    logoutUri: process.env.REACT_APP_APP_URL,
  };
  
  export default authConfig;